import { useCallback, useMemo, useState } from "react";
import type { DetalleProducto } from "../types/productoSeleccionado.types";
import { calcularTotalPedido } from "../utils/productoSeleccionado.utils";

/**
 * Opcional: maneja la lista de productos agregados.
 * Úsalo en requisicion.tsx si todavía no tienes este estado allá.
 */
export const useDetallesProducto = (inicial: DetalleProducto[] = []) => {
    const [detalles, setDetalles] = useState<DetalleProducto[]>(inicial);

    const handleAddDetalle = useCallback((detalle: DetalleProducto) => {
        setDetalles((actual) => [...actual, detalle]);
    }, []);

    const handleRemoveDetalle = useCallback((indice: number) => {
        setDetalles((actual) => actual.filter((_, i) => i !== indice));
    }, []);

    const limpiarDetalles = useCallback(() => setDetalles([]), []);

    const totalPedido = useMemo(() => calcularTotalPedido(detalles), [detalles]);

    return {
        detalles,
        setDetalles,
        handleAddDetalle,
        handleRemoveDetalle,
        limpiarDetalles,
        totalPedido,
    };
};
